export const messageConstants = {
    icons: {
        success: "success",
        error: "error",
        warning: "warning",
        info: "info",
        question: "question"
    }
};
